import { Skeleton, Td, Tr } from '@chakra-ui/react';

interface SkeletonTableItemProps {
  cols: number;
  count?: number;
}

export const SkeletonTable = ({ cols, count = 10 }: SkeletonTableItemProps) => {
  const totalsCount = Array.from({ length: count });
  const totalCols = Array.from({ length: cols });
  return (
    <>
      {totalsCount.map((_, rowIndex) => (
        <Tr key={rowIndex}>
          {totalCols.map((_, colIndex) => (
            <Td key={colIndex}>
              <Skeleton  h='kilo' />
            </Td>
          ))}
        </Tr>
      ))}
    </>
  );
};
